module.exports = __webpack_public_path__ + "static/media/键入时自动推荐与补全).4bb43510.png";